const INITIAL_STATE = {
    purchase_listing: [],
    listingMeta: null,
    listing_tbl_page: 1,

    purchaseSearchForm: null,
    submittedPurchaseFilterForm: null,

    formSearchedElems: [],

    searchedVendor: [],
    searchedItem: [],

    criteriaHeight: 0,
    hasLoaded: false,
};

export default function purchaseListReducer(state = INITIAL_STATE, action) {

    switch (action.type) {

        case "SET_PURCHASE_LIST_STATE":
            return {
                ...state,
                ...action.payload
            };

        case "CLEAR_PURCHASE_LIST_STATE":
            return INITIAL_STATE;

        default:
            return state;
    }
}